module.exports = __webpack_public_path__ + "media/src/application/media/rooms/library2-eba3239948feebc5570d581b07fc0cec.jpg";